import React, { useRef, useState, useEffect } from "react";
import View from 'src/components/view';
import Element from 'src/components/element';
import Button from '@material-ui/core/Button';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import utils from 'src/components/utils';

const DowloadArquivosClientes = function () {
  
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {} });
  let [ready, setReady] = useState(false);
  let [index, setIndex] = useState(0);

  const user = utils.getUser();
  const clienteLogado = utils.getCliente();

  let [idArquivo, setIdArquivo] = useState(null);
  let [arquivoCliente, setArquivoCliente] = useState(null);
  let [listaAnexos, setListaAnexos] = useState([]);

  const galleryRef = useRef();
  let [indexAtual, setIndexAtual] = useState(0);
  let [descricaoImgAtual, setDescricaoImgAtual] = useState('');
  
  let urlParts = window.location.pathname.substring(1).split('/');

  const loadArquivoCliente = function(idArquivoCliente) {
    if (idArquivoCliente && idArquivoCliente > 0) {
      utils.execute(crud, 'ArquivoCliente/' + idArquivoCliente + '?lazy=false&resume=false', null, function (res) {
        if (res.data && res.data.id > 0) {
          arquivoCliente = res.data;
          setArquivoCliente(arquivoCliente);

          if (arquivoCliente.anexos) {
            
            listaAnexos = arquivoCliente.anexos.map(img => ({
              original: img.linkAnexo,
              thumbnail: img.linkAnexo
            }));

            setListaAnexos(listaAnexos);
            slideImg(0);
          }
        }
      }, true);
    }
  };

  crud.refresh = function () {
    setIndex(index + 1);
    setCrud(crud);
  };

  useEffect(() => {
    if (!ready) {
      setReady(true);

      if (urlParts.length > 1) {
        idArquivo = urlParts[1];
        setIdArquivo(idArquivo);
        if (idArquivo && idArquivo > 0) {
          loadArquivoCliente(idArquivo);
        }
      }
    }
  });

  crud.openArquivoCliente =function(el,args){
    if (args && args.data && args.data.id && args.data.id > 0) {
      reload(args.data.id);
    }
  };

  let list = {
    layout: "table",
    header: true,
    search: true,
    filter: true,
    name: "arquivos_clientes",
    field: "arquivos_clientes",
    type: "list",
    space: 12,
    size: 10,
    edit: true,
    visible: true,
    required: false,
    label: utils.lng("gerenciador_arquivos_clientes","Gerenciamento Arquivos Clientes"),
    controls: true,
    entity: 'ArquivoCliente',
    filters: {
      cliente: {
        type: 'text',
        label: utils.lng("cliente", "Cliente")
      }
    },
    columns: {
      id: {
        layout: "span",
        styleClass: "ui-component ",
        type: "column",
        type: "number",
        label: "ID",
        name: "id",
        field: "id",
        visible: true,
        space: 2
      },
      tipo: {
        layout: "span", 
        styleClass: "ui-component ", 
        type: "column",
        type: "text",
        label: utils.lng("tipo", "Tipo"), 
        name: "tipo", 
        field: "tipo", 
        space: 5
      },
      cliente: {
        layout: "span",
        styleClass: "ui-component ",
        type: "column",
        type: "text",
        label: utils.lng("cliente", "Cliente"),
        name: "cliente",
        field: "cliente",
        visible: true,
        space: 5
      }
      // dh_registro: {
      //   // layout: "span",
      //   // styleClass: "ui-component ",
      //   type: "date",
      //   label: utils.lng("data", "Data"),
      //   name: "dh_registro",
      //   field: "dh_registro",
      //   space: 3
      // },
      // descricao: {
      //   layout: "span",
      //   styleClass: "ui-component ",
      //   label: utils.lng("descricao", "Descrição"),
      //   name: "descricao",
      //   field: "descricao",
      //   type: "column",
      //   space: 2
      // }
    },
    click: {
      action: "openArquivoCliente"
    },
    list: {
      url: "/listarArquivosClientes",
      method: "GET"
    }
  };

  const voltarListagem = function () {
    reload();
  };

  const reload = function(idReload) {
    window.location.href = '/download_arquivos_clientes'+(idReload ? '/'+idReload : '');
  }

  const slideImg = function(index)  {
    indexAtual = index
    setIndexAtual(indexAtual);
    descricaoImgAtual = '';
    if (listaAnexos) {
      let anexo = arquivoCliente.anexos[indexAtual];
      if (anexo) {
        descricaoImgAtual = anexo.descricao;
      }
    }
    setDescricaoImgAtual(descricaoImgAtual);
  };

  const downloadImagem = function() {
    if (listaAnexos) {
      let imagemSelecionada = listaAnexos[indexAtual];
      if (imagemSelecionada) {
        executaDowloadArquivo(imagemSelecionada);
      }
    }
  };

  const downloadTodasImagens = function(index) {
    if (listaAnexos && listaAnexos[index]) {
      for (let i = 0; i < listaAnexos.length; i++) {
        const img = listaAnexos[i];
        let w = window.open(img.original);
      }
      // let imagemSelecionada = listaAnexos[index];
      // // setTimeout( () => { executaDowloadArquivo(imagemSelecionada) }, 1000);
      // let w = window.open(imagemSelecionada.original);
      // if (index < listaAnexos.length) {
      //   downloadTodasImagens(index++);
      // }
    }
  };

  // const downloadTodasImagens = async () => {
  //   if (listaAnexos) {
  //     const zip = new JSZip();
  //     for (let i = 0; i < listaAnexos.length; i++) {
  //       const img = listaAnexos[i];
  //       const response = await fetch(img.original);
  //       const blob = await response.blob();
  //       zip.file(img.original.split('/').pop(), blob);
  //     }
  //     const content = await zip.generateAsync({ type: "blob" });
  //     saveAs(content, "imagens"+arquivoCliente.cliente.descricao+".zip");
  //   }
  // };

  const executaDowloadArquivo = function(imagemSelecionada) {
    if (imagemSelecionada) {
      const link = document.createElement('a');
      link.href = imagemSelecionada.original;
      link.download = imagemSelecionada.original.split('/').pop();
      link.click();
    }
  };

  return (
    <View view={view} name="arquivo_cliente">
      
      {idArquivo && idArquivo >= 0 && 
        
        <div>
          {arquivoCliente && arquivoCliente.cliente && listaAnexos &&
            <>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                height: '30px',
                paddingTop: '20px',
                fontSize: '35px',
                fontWeight: '500px',
                textAlign: 'center'
              }}>
                <p>{arquivoCliente.cliente.descricao+': '+arquivoCliente.tipo.descricao}</p>
              </div>
              <div className="ui-download-arq-cliente-content">
                <ImageGallery
                  ref={galleryRef}
                  onSlide={slideImg}
                  items={listaAnexos}
                  showPlayButton={false}
                  showFullscreenButton={false}
                  showBullets={false}
                  showNav={true}
                  thumbnailPosition="bottom" 
                  additionalClass="custom-gallery"
                />
              </div>
              
              <Button id="btn_download" onClick={downloadImagem} color="primary" style={{
                position: 'absolute', top: '20%', right: '7%', zIndex: 10
              }} title={utils.lng('baixar_foto_selecionada', 'Baixar Foto Selecionada')}>
                <i className="fas fa-image fa-2x" style={{ marginLeft: '10px', marginRight: '8px' }}></i>
              </Button>

              <Button id="btn_download_all" onClick={ () => { downloadTodasImagens(0) } } color="primary" style={{
                position: 'absolute', top: '20%', right: '4%', zIndex: 10
              }} title={utils.lng('baixar_todas_fotos_lista', 'Baixar Todas as Fotos da Lista')}>
                <i className="fa fa-download fa-2x" style={{ marginLeft: '10px', marginRight: '8px' }}></i>
              </Button>
              
              <Button id="btn_fechar" onClick={() => { reload() }} variant="contained" color="secondary" style={{
                position: 'absolute', top: '90%', right: '7%', zIndex: 10
              }}>>
                {utils.lng('fechar','Fechar')}
              </Button>
            </>
          }
        </div>
      }
      {!idArquivo &&
        <>
          <Element value={list} crud={crud} data={crud.data} view={view} ></Element>
        </>
      }
    </View>
  );
}

export default DowloadArquivosClientes;
